import LocalSettings from './local-settings/local-settings';
import {RenderModeOption, TableRenderMode} from "../../gd-modules/table/@types";
// This is old shit nado kak nit' razobratysya
// chto tut

const defaults = {

    'global': {
        filterOrganization: 'all'
    },

    'mywork': {

        viewType: 'schedule',
        view: 'board',
        widget: 'note',

        showSomedayActionRequiredFromUser: '1',
        showSomedayActionRequiredProject: '1',
        showSomedayAssignedToMe: '1',
        showSomedayAllInvolved: '1',

        collapsedActionRequiredProject: '',
        collapsedAssignedToMe: '',
        collapsedAllInvolved: '',
        collapsedRecent: '',

        'last:AR.View': 'schedule',

        viewForUserId: ''
    },

    'startpage': {
        project: 'overview',
        user: 'dashboard',
        organization: 'dashboard',
        events: 'calendar',
        savePageSkipOnce: '0',
    },

    'new': {
        projectView: 'simple',
        showSharedTemplates: '0',
        openedSharedTemplates: ''
    },

    'new.task.inline' : {
        priority: '0',
        deadline: '0',
        estimate: '0',
    },

    'menu': {
        openItem: ''
    },

    'gd.task-view': {
        viewLevel: '2',

        viewOpen: '0',
        usersOpen: '0',
        customFieldsOpen: '1',
        timeReportsOpen: '0',

        // layout: 'modal',

        dependsOnOpen: '1',
        dependsOnHideCompleted: '0',

        dependentTasksOpen: '1',
        dependentTasksHideCompleted: '0',

        subtasksOpen: '1',
        subtasksHideCompleted: '0',

        todoOpen: '1',
        todoHideCompleted: '0'

        // completedOpen: '1'
    },

    'user.tasks': {
        viewBy: 'actionRequired',

        filters: '1',

        filterViewOpen: '1',
        filterParentOpen: '0',
        filterUserOpen: '0'
    },

    'gd.table': {
        stickyTitleEnabled  : '1',
        renderMode          : RenderModeOption.AUTO
        // displayRowNumbersEnabled: '1'
    },

    'gantt': {
        workdayStretchType: 'exclude-holidays',
        displayAssignedUserAvatar: '1',
        displayProjectOwnerAvatar: '1',
        displayRowNumbersEnabled: '1',
    },

    'task.list':{
        groupsHeaderType: 'colored',
    },

    'timeline': {
        // pillsSizeType: 'pillsSizeTypeSmall',
        pillsViewType               : 'pillsViewTypeColoredLight',
        pillsColorFieldId           : 'statusId',
        pillsTitleType              : 'pillsTitleTypeTitle',
        workdayStretchType          : 'exclude-holidays',
        personalEvents              : 'personal_vacation,personal_sick,personal_travel',
        organizationEvents          : 'organization_holiday',
        projectEvents               : 'project_milestone,project_event',
        autoDistributionDefaultType : 'auto_front_load'
    },

    'gd.project.tasks.view': {
        lastVisitedSection: null
    },
};

export default class GlobalSettings {

    public global   : LocalSettings
    public initializedSettings   : any

    constructor() {

        this.global = new LocalSettings("global",{
            filterOrganization: 'all'
        });

        this.initializedSettings = {};
    }

    get myWork() { return this.get('mywork'); }

    get menu() { return this.get('menu'); }

    get new() { return this.get('new'); }

    get newTaskInline() { return this.get('new.task.inline'); }

    get taskView() { return this.get('gd.task-view'); }

    get userTasks() { return this.get('user.tasks'); }

    get table() {return this.get('gd.table'); }

    get gantt() { return this.get('gantt'); }

    get taskList() { return this.get('task.list'); }

    get timeline() { return this.get('timeline'); }

    get projectTaskView() { return this.get('gd.project.tasks.view'); }

    get(name:string) {

        if (this.initializedSettings[name]) return this.initializedSettings[name];

        // @ts-ignore
        if (!defaults[name]) {
            gd.growl.error('Unknown settings name');
            return false;
        }

        // initialize
        // @ts-ignore
        this.initializedSettings[name] = new LocalSettings(name,defaults[name]);
        return this.initializedSettings[name];
    }

    getWithProto(protoName:string, name:string) {
        if (this.initializedSettings[name]) return this.initializedSettings[name];

        // @ts-ignore
        if (!defaults[protoName]) {
            gd.growl.error('Unknown settings name');
            return false;
        }

        // initialize
        // @ts-ignore
        this.initializedSettings[name] = new LocalSettings(name, defaults[protoName]);
        return this.initializedSettings[name];
    }
}